"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./data/types");
var resources_1 = __importDefault(require("./resources"));
var player_1 = __importDefault(require("./player"));
var farm_1 = __importDefault(require("./farm"));
var weapon_1 = __importDefault(require("./items/weapon"));
var weaponcraefter_1 = __importDefault(require("./craefter/weaponcraefter"));
var armorcraefter_1 = __importDefault(require("./craefter/armorcraefter"));
var serializer_1 = __importDefault(require("@craeft/serializer"));
var mathjs_1 = require("mathjs");
var config_1 = __importDefault(require("../config"));
// storage
var local_storage_1 = __importDefault(require("local-storage"));
var lz_string_1 = __importDefault(require("lz-string/libs/lz-string"));
var items_1 = __importDefault(require("./items/items"));
var craefters_1 = __importDefault(require("./craefter/craefters"));
var bosses_1 = __importDefault(require("./boss/bosses"));
var generator_1 = require("@craeft/map-generator/src/map/generator");
var TerrainTypes_1 = require("@craeft/map-generator/src/TerrainTypes");
var version = "v" + process.env.REACT_APP_VERSION;
var versionMsg = "Welcome to Cr\u00E4ft! version: " + version;
/* eslint-disable-next-line no-console */
console.log(versionMsg);
if (config_1.default.debug) {
    console.log("Running in debug mode!");
}
var Craeft = /** @class */ (function () {
    function Craeft() {
        var _this = this;
        this.logs = [
            versionMsg
        ];
        this.gameTick = null;
        this.onTick = null;
        this.ticker = 0;
        this.player = new player_1.default();
        this.farm = new farm_1.default();
        this.craefters = new craefters_1.default();
        this.items = new items_1.default();
        this.bosses = new bosses_1.default();
        generator_1.generate({
            height: 200,
            width: 200,
            treeChance: 30,
            pondMax: 5
        }).then(function (map) { return _this.map = map; });
        this.resources = new resources_1.default({
            initialResources: config_1.default.startResources
        });
        var knife = new weapon_1.default({
            name: "Newbie Knife",
            type: types_1.WeaponTypes.Knife,
            material: types_1.ResourceTypes.Metal,
            rarity: types_1.Rarities.Common,
            atk: 1,
            matk: 1,
            delay: -1
        });
        knife.equipped = this.player.equipment.equip(knife);
        this.items.push(knife);
    }
    Craeft.prototype.serialize = function () {
        return serializer_1.default.serialize({
            obj: this,
            compress: true
        });
    };
    Craeft.prototype.move = function (direction) {
        if (!this.map) {
            return;
        }
        if (this.player.staCurrent >= 1) {
            var results = this.map.move(direction);
            if (results.hasMoved) {
                var a = 1;
                if (results.terrain === TerrainTypes_1.TerrainTypes.Tree) {
                    a *= 2;
                }
                else if (results.terrain === TerrainTypes_1.TerrainTypes.Water) {
                    a *= 4;
                }
                this.player.exhaust(a);
            }
        }
    };
    Craeft.deserialize = function (json) {
        var obj = serializer_1.default.deserialize(json);
        var craeft = Object.assign(new Craeft(), obj);
        craeft.resources = resources_1.default.hydrate(obj.resources);
        craeft.farm = farm_1.default.hydrate(obj.farm);
        craeft.items = items_1.default.hydrate(obj.items);
        craeft.craefters = craefters_1.default.hydrate(obj.craefters);
        craeft.bosses = bosses_1.default.hydrate(obj.bosses);
        craeft.player = player_1.default.hydrate(obj.player);
        return craeft;
    };
    Craeft.prototype.tick = function () {
        var e_1, _a, e_2, _b;
        this.ticker++;
        // tick the player
        this.player.tick(this.ticker);
        try {
            // tick all craefters
            for (var _c = __values(this.craefters), _d = _c.next(); !_d.done; _d = _c.next()) {
                var craefter = _d.value;
                craefter.tick(this.ticker);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            // tick all the items
            for (var _e = __values(this.items), _f = _e.next(); !_f.done; _f = _e.next()) {
                var item = _f.value;
                item.tick(this.ticker);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_2) throw e_2.error; }
        }
        if (this.onTick) {
            this.onTick();
        }
    };
    Craeft.prototype.start = function (_a) {
        var _this = this;
        var onTick = (_a === void 0 ? {
            onTick: null
        } : _a).onTick;
        // re-render every second
        var timeoutInSeconds = 1;
        this.onTick = onTick;
        if (this.gameTick) {
            this.stop();
        }
        this.gameTick = window.setInterval(function () {
            _this.ticker = 0;
            _this.tick();
        }, timeoutInSeconds * 1000);
    };
    Craeft.prototype.stop = function (hard) {
        if (this.gameTick) {
            window.clearInterval(this.gameTick);
        }
        this.gameTick = null;
        // final tick
        this.tick();
        if (hard) {
            Craeft.deleteState();
        }
    };
    Craeft.prototype.startFarming = function (_a) {
        var _this = this;
        var callback = _a.callback;
        if (!this.player.isFarming &&
            this.player.staCurrent > 0) {
            this.player.isFarming = true;
            this.farm.start({
                player: this.player,
                callback: function (_a) {
                    var result = _a.result, dmg = _a.dmg, exp = _a.exp, usedStamina = _a.usedStamina;
                    _this.resources = new resources_1.default()
                        .add(_this.resources)
                        .add(result);
                    _this.player.takeDamage(dmg);
                    _this.player.addExp(exp);
                    _this.player.exhaust(usedStamina);
                    _this.player.isFarming = false;
                    callback();
                }
            });
        }
    };
    Craeft.prototype.addItem = function (item, resourcesConsumed) {
        var _this = this;
        this.resources.sub(resourcesConsumed);
        item.onDoneCreating = function (craefterId, exp) {
            var craefter = _this.craefters.findById(craefterId);
            craefter.finishCraefting(exp);
            _this.logs.push("\"" + item.getName() + "\" cr\u00E4fted by " + craefter.name + "! ");
        };
        this.items.push(item);
    };
    Craeft.prototype.addCraefter = function (which) {
        var _this = this;
        var craefter;
        var delay = config_1.default.startDelay * mathjs_1.pow(mathjs_1.log(this.craefters.count + 2), 20);
        switch (which) {
            case types_1.CraefterTypes.WeaponCraefter:
                craefter = new weaponcraefter_1.default({
                    delay: delay
                });
                break;
            case types_1.CraefterTypes.ArmorCraefter:
                craefter = new armorcraefter_1.default({
                    delay: delay
                });
                break;
            default:
                throw new Error("Unknown craefter type");
        }
        this.craefters.push(craefter);
        craefter.onDoneCreating = function (exp) {
            _this.player.addExp(exp);
        };
    };
    Craeft.prototype.disentchant = function (itemId) {
        console.log(this.items);
        var result = this.items.disentchant(itemId);
        this.resources = new resources_1.default({
            resources: this.resources
        })
            .add(result.resources);
        this.logs.push("\"" + result.name + "\" disenchanted! " + result.resources.sum() + " resource(s) retrieved!");
    };
    Craeft.prototype.equipItem = function (item) {
        var equipped = false;
        if (!this.player.isFarming) {
            equipped = this.player.equipment.equip(item);
            if (equipped) {
                item.equipped = equipped;
                this.logs.push("\"" + item.getName() + "\" put on.");
            }
            else {
                this.logs.push("Equip failed!");
            }
        }
        return equipped;
    };
    Craeft.prototype.unEquipItem = function (itemId) {
        var unequipped = false;
        if (!this.player.isFarming) {
            unequipped = this.player.equipment.unequip(itemId);
            if (unequipped) {
                var item = this.items.find(function (i) { return i.id === itemId; });
                item.equipped = !unequipped;
                this.logs.push("\"" + item.getName() + "\" taken off.");
            }
            else {
                this.logs.push("Unequip failed!");
            }
        }
        return unequipped;
    };
    Craeft.saveState = function () {
        if (config_1.default.useLocalStorage && !global.craeft.player.dead) {
            var state = global.craeft.serialize();
            // @ts-ignore
            local_storage_1.default.set("state", config_1.default.compressLocalStorage ?
                lz_string_1.default.compress(state) : state);
            return true;
        }
        return false;
    };
    Craeft.loadState = function () {
        var state = null;
        if (config_1.default.useLocalStorage) {
            // @ts-ignore
            var localState = local_storage_1.default.get("state");
            if (localState) {
                // if the state starts with { it is uncompressed
                state = localState.startsWith("{") ?
                    localState : lz_string_1.default.decompress(localState);
            }
            if (state) {
                global.craeft = Craeft.deserialize(state);
            }
        }
    };
    Craeft.deleteState = function () {
        if (config_1.default.useLocalStorage) {
            // @ts-ignore
            local_storage_1.default.remove("state");
        }
    };
    return Craeft;
}());
exports.default = Craeft;
global.craeft = new Craeft();
